"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positiveNumberOrString = exports.isPrecisionBiggerThan16 = exports.mathFloor = exports.mathLog10 = void 0;
/**
 * Math.log10 的 Polyfill, 用换底公式, 由于 ie 不支持
 * @param input 输入数值
 */
function mathLog10(input) {
    return Math.log10 ? Math.log10(input) : Math.log(input) * Math.LOG10E;
}
exports.mathLog10 = mathLog10;
/**
 * 返回小于或等于一个给定数字的最大整数字符串, 作用与 Math.floor 相同
 * @param val 输入数字
 */
function mathFloor(val) {
    // 32位表示范围内用位运算可以加快运算
    if (val > -2147483648 && val < 2147483647) {
        return "" + (val >= 0 ? (val | 0) : ((val - 1) | 0));
    }
    return "" + Math.floor(val);
}
exports.mathFloor = mathFloor;
/**
 * 判断数字或者字符串精度是否超过 16
 * @param val 需要处理的数字或者字符串
 */
function isPrecisionBiggerThan16(val) {
    // 如果本来就是数字的话, 自然不会超 16 位精度, 那就不需要判断了
    if (typeof val === 'number') {
        return false;
    }
    // 为空精度必然不超过 16
    if (!val) {
        return false;
    }
    var dot = val.indexOf('.');
    var valueWithoutDot = val;
    if (dot !== -1) {
        // 将小数转换为整数, 然后再统一算精度
        valueWithoutDot = val.substr(0, dot) + val.substr(dot + 1, val.length);
    }
    valueWithoutDot = valueWithoutDot.replace(/[+-]/, ''); // 处理正负号
    valueWithoutDot = valueWithoutDot.toUpperCase();
    var exp = valueWithoutDot.indexOf('E');
    if (exp !== -1) {
        // 将科学计数 E 后面的部分去掉
        valueWithoutDot = valueWithoutDot.substr(0, exp);
    }
    var regResult = valueWithoutDot.match(/0*([1-9]([0-9]*[1-9])?)0*$/);
    return !!(regResult && regResult[1].length > 16);
}
exports.isPrecisionBiggerThan16 = isPrecisionBiggerThan16;
/**
 * 为数字或字符串负值取反操作
 * @param val 需要处理的数字或者字符串
 */
function positiveNumberOrString(val) {
    // 当 val 为 string 时, 由于本身是负值所以直接去掉首位负号
    return typeof val === 'number' ? -val : val.slice(1);
}
exports.positiveNumberOrString = positiveNumberOrString;
//# sourceMappingURL=math.js.map